import {
  SelfServeRequestGroupForm,
  ISelfServeRequestGroupFormSubmitProps
} from './self-serve-request-group-form.component';
import { IFormWithStepperProps } from '../../../_core/form/form.types';
import { logError } from '../../../../lib/utils';
import { resetFormMessages } from '../../../_core/form/form.helpers';
import { IRequestGroupUnauthenticatedOverview } from '../../../../lib/types';
import { useSelfServeRequest } from '../request-group.service';

interface ISelfServeRequestGroupContainer extends IFormWithStepperProps {
  group: IRequestGroupUnauthenticatedOverview;
}

export const SelfServeRequestGroupNestedContainer = ({
  group,
  onError,
  onSuccess
}: ISelfServeRequestGroupContainer) => {
  const { selfServeRequest } = useSelfServeRequest(group);

  const handleAccept = async ({ resetForm, ...rest }: ISelfServeRequestGroupFormSubmitProps) => {
    try {
      await resetFormMessages({ setSubmitError: onError, setSuccess: onSuccess });

      if (await selfServeRequest(rest)) {
        onSuccess?.('Check your email for your request invite');
        resetForm?.({ values: { givenName: '', familyName: '', email: '' } });
      }
    } catch (err) {
      const errorMessage = (err as Error).message.toLowerCase();

      let msg = 'Failed to request access';
      if (errorMessage.includes('is expired')) msg = 'Bulk request has expired';

      logError(msg, errorMessage);
      onError?.(msg);
    }
  };

  return <SelfServeRequestGroupForm group={group} onSubmit={handleAccept} />;
};
